import { render, staticRenderFns } from "./ProfileMainInfo.vue?vue&type=template&id=273ec40a&scoped=true&"
import script from "./ProfileMainInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileMainInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMainInfo.vue?vue&type=style&index=0&id=273ec40a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273ec40a",
  null
  
)

export default component.exports